import Component from '../abstracts/Component';
import ChatUtils from '../utils/ChatUtils';

/**
 Chat component
 */
export default class ChatComponent extends Component {

  constructor() {
    super();
  }

  bindEvents() {
    // listen to events , if needed
    // afterMinimize
    document.addEventListener('startChat', () => {
      this.$emit(this.$customEvents.CHAT_EVENTS.opened);
    });

    document.addEventListener('closeChat', ()=>{
      this.$emit(this.$customEvents.CHAT_EVENTS.closed);
    })

    document.addEventListener('afterMinimize',  (event) => {
      let btn = document.querySelector('.sidebarHeader.minimizedContainer.helpButton.embeddedServiceSidebarMinimizedDefaultUI')
      if ( btn != null) {
        btn.innerHTML =  '<div class="icon-live-chat"></div>';
        btn.addEventListener('click', (e)=>{
          const container = e.target.closest('.modalContainer');
          if (container && container.classList.contains('sidebarMaximized')) {
            this.$emit(this.$customEvents.CHAT_EVENTS.unminimize);
          }
        })
      }

      this.$emit(this.$customEvents.CHAT_EVENTS.minimize);
    }, false);


    // contact us button
    let liveChatButtons = document.querySelectorAll('a[data-name=live-chat], [data-node-name=live-chat] a');
    // button online
    this.$on('chatButtonEnabled', (e) => {
      if (liveChatButtons != null) {
        // start chat button
        var btn = document.querySelector(ChatUtils.SELECTORS.chatButton);
        // cycle all buttons
        liveChatButtons.forEach( liveChatButton => {
          liveChatButton.classList.remove('not-available');
          liveChatButton.classList.add('available');
          liveChatButton.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            if (btn != null) {
              btn.click();
            }
          });
        });
      }
    });
    // button offline
    this.$on('chatButtonDisabled', (e) => {
      if (liveChatButtons != null) {
        liveChatButtons.forEach( liveChatButton => {
          liveChatButton.classList.add('not-available');
          liveChatButton.classList.remove('available');
          liveChatButton.removeEventListener('click',function(){});
        });
      }
    });

  }

  /////
  render() {
    this.log('rendering...');
    // some events
    this.bindEvents();
    // check if new chat is enabled
    let chatEnabled = (document.querySelector('#chatEnabled') != null) ? document.querySelector('#chatEnabled').value : false;
    // if is enabled let's launch it
    if (chatEnabled === 'true') {
      // script call
      let script = ChatUtils.getValue('urlEnvironmentSF')+'/embeddedservice/5.0/esw.min.js';
      // get script and initialize chat
      this.moduleLoader.loadExternalScript(script).then(() => {
        this.log('loading...');
        let options = {
          subjects: {
            chatLabelSubject: '',
            chatLabelSubjectOptionOD: 'Orders and deliveries',
            chatLabelSubjectOptionPay: 'Payment, promotions and Gift Cards',
            chatLabelSubjectOptionCS: 'Comments and Suggestions',
            chatLabelSubjectOptionPAv: 'Product information and availability',
            chatLabelSubjectOptionSt: 'Stores',
            chatLabelSubjectOptionRR: 'Refunds and Returns',
            chatLabelSubjectOptionTA: 'Technical assistance'
          },
          labelBindHiding: 'true',
          subjectIcon: 'true',
          subjectIconClass: [
            'icon-select',
            'icon-chevron-down'
          ]
        }
         if (ChatUtils.getValue('personalStylistSnapConfig')) {
          options.subjects = ChatUtils.addToObject(options.subjects,'chatLabelSubjectOptionPS','Personal Stylist',1);
        }
        // setup env
        ChatUtils.setEnvironment(options);
        // update cookie path
        ChatUtils.updatePath();
        // init the chat
        ChatUtils.initializeChat();
        // new chat modifier
        ChatUtils.runsNewChat();
      });
    }
  }
}
